import React, { useEffect } from "react";
import { TranslationProvider } from "../../context/TranslationProvider";
import { Outlet, useLoaderData, useLocation } from "react-router-dom";
import Header from "../Header";
import { RootApplicationStyled } from "./RootApplicationStyled";
import Aside from "../Aside";
import MixtureTab from "../MixtureTab";
import { LoaderDataInterface } from "../../entities/Route";
import { useAppDispatch } from "../../store/store";
import { setTenantState } from "../Tenant/TenantSlice";
import { useSelector } from "react-redux";
import { getTenantCredentials } from "../Tenant/selectors";
import Main from "../Main";
import { setSettingMix } from "../Mixture/MixtureSlice";
import Modal from "../Modal";

const RootApplication: React.FC = () => {
  const location = useLocation();
  const tenantCredentials = useSelector(getTenantCredentials);
  const dispatch = useAppDispatch();
  const { credentials, defaultTranslations, settings, url } =
    useLoaderData<LoaderDataInterface>();

  useEffect(() => {
    dispatch(setTenantState({ credentials }));
    dispatch(setSettingMix(settings));
  }, [dispatch, credentials, settings]);

  return (
    <TranslationProvider defaultTranslations={defaultTranslations}>
      <Main credentials={credentials}>
        <Header credentials={credentials} url={url} />
        <Modal />
        {tenantCredentials && (
          <RootApplicationStyled
            className={location.pathname
              .replaceAll("/", "_")
              .replaceAll("-", "_")
              .toUpperCase()}
          >
            <Aside />
            <div className="outlet-wrapper">
              <Outlet />
            </div>
            <MixtureTab />
          </RootApplicationStyled>
        )}
      </Main>
    </TranslationProvider>
  );
};

export default RootApplication;
